import {QuantityType} from "../../../lib/src/api/dto/QuantityType"
import React, {FC, useState} from "react";
import { Card } from "@traas/lib/src/components/Card";
import {Input } from "@traas/lib/src/components/form/Input";
import {useApi} from "../api/APIContext";
import { Toggle } from "@traas/lib/src/components/form/Toggle";
import { ObjectAutocomplete } from "@traas/lib/src/components/form/Autocomplete";
import { Button } from "@traas/lib/src/components/form/Button";
import {Color} from "@traas/lib/src/api/dto/Color";

export const TaskTypeDetailsCard: FC<{taskType: QuantityType}> = props => {
  const {addQuantityType, editQuantityType, colors} = useApi()

  const [name, setName] = useState(props.taskType.name)
  const [color, setColor] = React.useState<Color>(colors.find(c => c.id === props.taskType.defaultColor) ?? {id: 'null', name: 'Geen standaardkleur', color: 'slate'} as Color)
  const [hideArea, setHideArea] = React.useState<boolean>(props.taskType.hideArea ?? false)
  const [shouldMakeWorkorder, setShouldMakeWorkorder] = React.useState<boolean>(props.taskType.shouldGenerateWorkorder ?? false)
  const [countsForManDaySheet, setCountsForManDaySheet] = React.useState<boolean>(props.taskType.countsForManDaySheet ?? true)

  const confirm = async () => {
    const addOrEdit = (name: string, enabled: boolean, defaultColor: string|null, descriptionTemplate: string[], hideArea: boolean, shouldMakeWorkorder: boolean, countsForManDaySheet: boolean) => props.taskType?.id ? editQuantityType(props.taskType?.id, name, enabled, defaultColor, descriptionTemplate, hideArea, shouldMakeWorkorder, countsForManDaySheet) : addQuantityType(name, enabled, defaultColor, descriptionTemplate, hideArea, shouldMakeWorkorder, countsForManDaySheet)
    await addOrEdit(name, props.taskType.enabled ?? true, color.id === 'null' ? null : color.id, props.taskType.descriptionTemplate, hideArea, shouldMakeWorkorder, countsForManDaySheet)
      .catch(e => {
        throw e
      })
  }

  const options = [
    {id: 'null', name: 'Geen standaardkleur', color: 'slate'} as Color,
    ...colors,
  ]

  return <Card title={'Bewerken'}>
    <div className={'grid grid-cols-2 gap-4 mb-4'}>
      <Input type={'text'} label={'Naam'} value={name} onChange={setName} />
      <ObjectAutocomplete label={'Standaardkleur'} options={options} value={color} onChange={setColor} displayItem={(c) => c.name} idProperty={'id'}/>
      <div className={'flex flex-col space-y-4'}>
        <Toggle label={"Maak werkbon aan"} value={shouldMakeWorkorder} onChange={setShouldMakeWorkorder} size={'sm'}/>
        <Toggle label={"Verberg m²"} value={hideArea} onChange={setHideArea} size={'sm'}/>
        <Toggle label={"Telt mee voor mandagen-staat"} value={countsForManDaySheet} onChange={setCountsForManDaySheet} size={'sm'}/>
      </div>
    </div>
    <Button type={'primary'} size={'md'} text={'Opslaan'} onClick={confirm} disabled={
      name === props.taskType.name
      && color.id === props.taskType.defaultColor
      && hideArea === props.taskType.hideArea
      && shouldMakeWorkorder === props.taskType.shouldGenerateWorkorder
      && countsForManDaySheet === props.taskType.countsForManDaySheet}
    />
  </Card>
}
